import { render, staticRenderFns } from "./BasketPage.vue?vue&type=template&id=76b8d8d1&scoped=true&"
import script from "./BasketPage.vue?vue&type=script&lang=ts&"
export * from "./BasketPage.vue?vue&type=script&lang=ts&"
import style0 from "./BasketPage.vue?vue&type=style&index=0&id=76b8d8d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8d8d1",
  null
  
)

export default component.exports